import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const PrivacyPolicy: React.FC = () => {
  // Enable scrolling for this page
  React.useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    const rootElement = document.getElementById('root');
    const originalRootOverflow = rootElement?.style.overflow || '';
    
    document.body.style.overflow = 'auto';
    if (rootElement) {
      rootElement.style.overflow = 'auto';
    }
    
    return () => {
      document.body.style.overflow = originalOverflow;
      if (rootElement) {
        rootElement.style.overflow = originalRootOverflow;
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 py-8 pb-16">
        <Link to="/" className="inline-flex items-center text-blue-600 hover:text-blue-700 mb-6">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Ana Sayfaya Dön
        </Link>
        
        <div className="bg-white rounded-lg shadow-md p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Gizlilik Politikası</h1>
          
          <div className="text-sm text-gray-600 mb-6">
            Son güncelleme: {new Date().toLocaleDateString('tr-TR')}
          </div>
          
          <div className="space-y-6 text-gray-700">
            <section>
              <h2 className="text-xl font-semibold mb-3">1. Giriş</h2>
              <p>
                Edesis Dijital Tahta uygulaması ("Uygulama") olarak, kullanıcılarımızın gizliliğini korumayı taahhüt ediyoruz. 
                Bu uygulama, Edesis sistemini kullanan eğitim kurumları ve bu kurumlara kayıtlı kullanıcılar için hazırlanmıştır. 
                Hariçten bireysel kullanıcı kaydı yapılmamaktadır. Bu gizlilik politikası, Uygulamamızı kullandığınızda 
                hangi bilgileri topladığımızı, nasıl kullandığımızı ve koruduğumuzu açıklar.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">2. Toplanan Bilgiler</h2>
              <p className="mb-3">Uygulamamız aşağıdaki bilgileri toplayabilir:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Hesap Bilgileri:</strong> Eğitim kurumunuz tarafından sağlanan kullanıcı adı, e-posta adresi ve şifrelenmiş giriş bilgileri</li>
                <li><strong>Kullanım Verileri:</strong> Çözülen sorular, çizimler ve kayıt verileri</li>
                <li><strong>Cihaz Bilgileri:</strong> Cihaz tipi, işletim sistemi sürümü, uygulama sürümü</li>
                <li><strong>Çizim Verileri:</strong> Tahta üzerinde yapılan çizimler ve notlar (sadece kaydetmeyi seçtiğinizde)</li>
                <li><strong>Kurum Bilgileri:</strong> Bağlı olduğunuz eğitim kurumu ve kurum kodu</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">3. Bilgilerin Kullanımı</h2>
              <p className="mb-3">Toplanan bilgiler şu amaçlarla kullanılır:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Kullanıcı hesabının yönetimi ve kimlik doğrulama</li>
                <li>Öğrenme ilerlemesinin takibi ve raporlanması</li>
                <li>Uygulama özelliklerinin sağlanması ve iyileştirilmesi</li>
                <li>Teknik destek ve müşteri hizmetlerinin sunulması</li>
                <li>Yasal yükümlülüklerin yerine getirilmesi</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">4. Veri Güvenliği</h2>
              <p>
                Verilerinizi korumak için endüstri standardı güvenlik önlemleri kullanıyoruz:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-3">
                <li>HTTPS ile şifrelenmiş veri iletimi</li>
                <li>Firebase güvenlik kuralları ile korunan veri depolama</li>
                <li>Düzenli güvenlik güncellemeleri</li>
                <li>Kullanıcı verilerine sınırlı erişim kontrolü</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">5. Veri Paylaşımı</h2>
              <p>
                Kişisel verilerinizi üçüncü taraflarla paylaşmıyoruz, satmıyoruz veya kiralamıyoruz. 
                Veriler yalnızca şu durumlarda paylaşılabilir:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-3">
                <li>Yasal zorunluluklar veya mahkeme kararları</li>
                <li>Kullanıcının açık izni ile</li>
                <li>Okul veya kurum yöneticileri ile (sadece eğitim amaçlı istatistikler)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">6. Veri Saklama</h2>
              <p>
                Verileriniz, hesabınız aktif olduğu sürece veya hizmet sağlamak için gerekli olduğu 
                sürece saklanır. Hesabınızı sildiğinizde, kişisel verileriniz 30 gün içinde sistemimizden 
                kalıcı olarak silinir.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">7. Çocukların Gizliliği</h2>
              <p>
                Uygulamamız eğitim amaçlı olup, 13 yaş altı çocuklar tarafından kullanılabilir. 
                13 yaş altı kullanıcılardan kişisel bilgi toplamadan önce ebeveyn izni gereklidir.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">8. Kullanıcı Hakları</h2>
              <p className="mb-3">Kullanıcılarımız aşağıdaki haklara sahiptir:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Kişisel verilerine erişim talep etme</li>
                <li>Verilerin düzeltilmesini veya silinmesini isteme</li>
                <li>Veri işlemeye itiraz etme</li>
                <li>Veri taşınabilirliği talep etme</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">9. Çerezler</h2>
              <p>
                Uygulamamız, oturum yönetimi ve kullanıcı tercihlerini saklamak için çerezler kullanır. 
                Bu çerezler, uygulamanın düzgün çalışması için gereklidir.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">10. Değişiklikler</h2>
              <p>
                Bu gizlilik politikasını zaman zaman güncelleyebiliriz. Önemli değişiklikler 
                yapıldığında, uygulama içi bildirim veya e-posta yoluyla bilgilendirileceksiniz.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">11. İletişim</h2>
              <p>
                Gizlilik politikamız hakkında sorularınız veya endişeleriniz varsa, 
                lütfen bizimle iletişime geçin:
              </p>
              <ul className="list-none mt-3 space-y-1">
                <li>E-posta: bilgi@sinavza.com</li>
                <li>Şirket: Sınavza Bilişim Teknolojileri Limited Şirketi</li>
                <li>Telefon: 0850 305 8000</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">12. Yasal Dayanak</h2>
              <p>
                Bu gizlilik politikası, 6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) ve 
                ilgili mevzuat uyarınca hazırlanmıştır.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;